// src/hooks/useGeo.js
import { useState, useEffect, useCallback, useRef } from 'react';
import { api } from '../services/api';

export const useGeo = (mallId, isActive = true) => {
  const [nearbyCoupons, setNearbyCoupons] = useState([]);
  const [position, setPosition] = useState(null);
  const [error, setError] = useState(null);
  const intervalRef = useRef(null);

  const poll = useCallback(async (lat, lng) => {
    if (!mallId) return;
    try {
      const result = await api.updateLocation({ latitude: lat, longitude: lng, mallId });
      if (result.coupons?.length) setNearbyCoupons(result.coupons);
    } catch (e) {
      console.error('Geo poll error:', e.message);
    }
  }, [mallId]);

  useEffect(() => {
    if (!isActive || !mallId) return;

    if (!navigator.geolocation) {
      setError('Geolocation not supported');
      return;
    }

    const startPolling = (lat, lng) => {
      setPosition({ lat, lng });
      poll(lat, lng);
      intervalRef.current = setInterval(() => {
        navigator.geolocation.getCurrentPosition(
          (p) => poll(p.coords.latitude, p.coords.longitude),
          (e) => setError(e.message)
        );
      }, 10000); // every 10 seconds
    };

    navigator.geolocation.getCurrentPosition(
      (p) => startPolling(p.coords.latitude, p.coords.longitude),
      (e) => setError(e.message)
    );

    return () => clearInterval(intervalRef.current);
  }, [mallId, isActive, poll]);

  return { nearbyCoupons, position, error };
};
